// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"CustomBreadcrumbs_breadcrumbs__iyBFa","breadcrumb":"CustomBreadcrumbs_breadcrumb__JQxRX"};